// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-1cc5c236]{background-color:#fff;font-size:1em;font-weight:400;padding:20px 30px;line-height:2em}.agreement .title[data-v-1cc5c236]{text-align:center;font-size:2em;font-weight:700;margin-bottom:1em}.agreement .title-sub[data-v-1cc5c236]{font-weight:700;font-size:1.5em}.agreement .indent[data-v-1cc5c236]{text-indent:2em}.agreement .test-underline[data-v-1cc5c236]{font-weight:700;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
